import React, { useState, useEffect, useRef } from "react";
import "./Header.scss";
import Logo from "../../assets/img/logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FiLogOut, FiUser } from "react-icons/fi";

const Header = () => {
  const {
    userInfo: { userResponse },
  } = useSelector((state) => state.userDetails) || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleSignOut = () => {
    dispatch({ type: "USER_LOGOUT" });
    localStorage.clear();
    navigate("/login");
  };

  // Close dropdown when clicking anywhere on the screen
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.body.addEventListener("click", handleClickOutside);
    return () => {
      document.body.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <header className="bg-white/95 backdrop-blur-md z-[99] sticky top-0 border-b border-gray-100 shadow-sm">
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <a href="#" className="-m-1.5 p-1.5 group">
            <span className="sr-only">EliteWash Admin</span>
            <img className="h-8 w-auto group-hover:scale-105 transition-transform duration-200" src={Logo} alt="EliteWash" />
          </a>
        </div>

        <div className="flex items-center space-x-4">
          {/* User Profile Dropdown */}
          <div
            className="lg:flex lg:flex-1 lg:justify-end items-center space-x-4 relative"
            ref={dropdownRef}
          >
            <div
              className="flex items-center space-x-3 cursor-pointer p-2 rounded-xl hover:bg-gray-50 transition-all duration-200 group"
              onClick={(e) => {
                e.stopPropagation();
                setDropdownOpen((prev) => !prev);
              }}
            >
              <div className="relative">
                <img
                  className="w-8 h-8 sm:w-10 sm:h-10 rounded-full ring-2 ring-gray-200 group-hover:ring-primaryRed transition-all duration-200"
                  src={
                    userResponse?.avatar ||
                    "https://flowbite.com/docs/images/people/profile-picture-5.jpg"
                  }
                  alt={userResponse?.name}
                />
                <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-primaryGreen rounded-full border-2 border-white"></div>
              </div>
              <div className="text-sm font-semibold text-gray-900 hidden sm:block">
                <p className="group-hover:text-primaryRed transition-colors duration-200">
                  Welcome, <span className="font-bold">{userResponse?.name}</span>
                </p>
              </div>
            </div>

            {dropdownOpen && (
              <div className="absolute right-0 top-12 mt-2 w-56 bg-white border border-gray-100 rounded-xl shadow-xl animate-fadeIn z-50">
                <div className="p-4 border-b border-gray-100">
                  <div className="flex items-center space-x-3">
                    <img
                      className="w-12 h-12 rounded-full"
                      src={
                        userResponse?.avatar ||
                        "https://flowbite.com/docs/images/people/profile-picture-5.jpg"
                      }
                      alt={userResponse?.name}
                    />
                    <div>
                      <p className="font-semibold text-gray-900">{userResponse?.name}</p>
                      <p className="text-sm text-gray-500">{userResponse?.email}</p>
                    </div>
                  </div>
                </div>
                
                <div className="p-2">
                  <button className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition-colors duration-200">
                    <FiUser className="w-4 h-4" />
                    <span>Profile Settings</span>
                  </button>
                  
                  <button
                    className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200 group mt-1"
                    onClick={handleSignOut}
                  >
                    <FiLogOut className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
                    <span>Sign Out</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
